import {createTheme, responsiveFontSizes} from "@mui/material/styles";



// Create a theme instance.
let theme = createTheme({


  typography: {
    fontFamily: [
      'MuseoSansCyrl', '"sans-serif"'
    ].join(','),
    button: {
      textTransform: 'none',
      fontWeight: "normal",
    }
  },
  palette: {
    mode: 'light',
    common: {},
    primary: {
      main: "#ffe45f",
    },
    info: {
      main: "#fff",
    },
    secondary:{
      main: "#ef4323"
    }
}});

theme = responsiveFontSizes(theme);

export default theme;